{
	"title": "Конспекты",
	"list": {
		"title": "Конспекты",
		"subtitle": "{notes, plural, one {# заметка} few {# заметки} many {# заметок} other {# заметки}} · {materials, plural, one {# материал} few {# материала} many {# материалов} other {# материала}}",
		"empty": "Пока нет конспектов",
		"emptyDescription": "Загрузи материал — мы сгенерируем структурированный конспект в трёх уровнях детальности.",
		"emptyFiltered": "Ничего не найдено по фильтрам",
		"resetFilters": "Сбросить фильтры",
		"create": "Создать конспект",
		"showMore": "Показать ещё",
		"errorTitle": "Не удалось загрузить конспекты",
		"errorHint": "Проверь соединение или попробуй ещё раз.",
		"noSource": "Без источника",
		"statusGenerating": "Генерируется",
		"statusFailed": "Ошибка",
		"generatingHint": "AI готовит конспект… Это может занять 1–2 минуты.",
		"generationFailedHint": "Не удалось сгенерировать. Откройте, чтобы повторить.",
		"aiBlocksCount": "{count, plural, one {# AI-блок} few {# AI-блока} many {# AI-блоков} other {# AI-блока}}",
		"actions": {
			"generate": "Сгенерировать",
			"createBlank": "Создать пустой",
			"createMenu": "Новый конспект",
			"createBlankFull": "Создать пустой конспект",
			"generateFull": "Сгенерировать из материала"
		},
		"swipeDelete": "Удалить",
		"filters": {
			"searchPlaceholder": "Поиск по конспектам…",
			"material": "Материал",
			"allMaterials": "Все материалы",
			"detailLevel": "Детальность",
			"allLevels": "Все уровни",
			"date": "Дата",
			"any": "За всё время",
			"today": "Сегодня",
			"week": "7 дней",
			"month": "30 дней",
			"view": "Вид",
			"sheetTitle": "Фильтры",
			"trigger": "Фильтры",
			"triggerCount": "Фильтры · {count}",
			"apply": "Показать"
		}
	},
	"detailLevel": {
		"summarized": "Сводка",
		"inDepth": "Подробный",
		"comprehensive": "Полный",
		"manual": "Ручной"
	},
	"detailLevels": {
		"label": "Уровень детальности",
		"summarized": "Краткий",
		"summarizedDescription": "Основные идеи и тезисы",
		"inDepth": "Подробный",
		"inDepthDescription": "Все ключевые понятия с примерами",
		"comprehensive": "Исчерпывающий",
		"comprehensiveDescription": "Полный разбор материала"
	},
	"generate": {
		"title": "Сгенерировать конспект",
		"fields": {
			"material": "Материал",
			"materialPlaceholder": "Выбери материал…",
			"detailLevel": "Уровень детальности",
			"locale": "Язык конспекта",
			"localeHint": "Совпадает с языком материала",
			"customInstructions": "Пожелания к конспекту",
			"customInstructionsPlaceholder": "Например: сделай упор на междоусобных войнах, добавь подробные таблицы и диаграммы…",
			"customInstructionsHint": "Необязательно. AI учтёт пожелания при генерации.",
			"materialEmpty": "Нет материалов",
			"materialEmptyHint": "Сначала загрузите материал — конспект собирается из него."
		},
		"levels": {
			"summarized": {
				"label": "Сводка",
				"pages": "~5–8 страниц",
				"description": "Главные тезисы для быстрого повтора",
				"time": "~1–2 мин"
			},
			"inDepth": {
				"label": "Подробный",
				"pages": "~10–20 страниц",
				"description": "Подробный разбор с примерами и источниками",
				"time": "~2–4 мин"
			},
			"comprehensive": {
				"label": "Полный",
				"pages": "20–40+ страниц",
				"description": "Максимум деталей, глоссарий, AI-блоки",
				"time": "~4–8 мин"
			}
		},
		"proOnly": "PRO",
		"submit": "Сгенерировать",
		"submitting": "Создаём…",
		"toastStarted": "Генерация началась — это займёт ~2 мин",
		"toastError": "Не удалось запустить генерацию. Попробуй ещё раз.",
		"toastSlow": "Конспект готовится дольше обычного — он появится в списке конспектов, как только будет готов.",
		"locked": "Недоступно"
	},
	"generation": {
		"starting": "Создаём конспект…",
		"inProgress": "Генерация конспекта",
		"stage": "Этап: {stage}",
		"ready": "Конспект готов",
		"failed": "Не удалось создать конспект",
		"retry": "Сгенерировать заново"
	},
	"editor": {
		"placeholder": "Начни писать или используй / для команд…",
		"starter": {
			"whatTitle": "Что это и почему важно",
			"whatBody": "Это центральный узел темы. Запомни ключевые идеи и проверь себя по карточкам.",
			"stagesTitle": "Стадии",
			"stage1": "Первая стадия",
			"stage2": "Вторая стадия",
			"stage3": "Третья стадия"
		},
		"untitled": "Без названия",
		"back": "Конспекты",
		"backToMaterial": "Материал",
		"history": "История версий",
		"regenerate": "Перегенерировать",
		"regenerateManualHint": "Доступно только для конспектов, созданных из материала",
		"more": "Ещё",
		"wordCount": "{count, plural, one {# слово} few {# слова} many {# слов} other {# слова}}",
		"readingMin": "{count, plural, one {# мин чтения} few {# мин чтения} many {# мин чтения} other {# мин чтения}}",
		"autosave": {
			"pending": "Сохранение…",
			"saved": "Автосохранено только что",
			"savedAgo": "Автосохранено {seconds} сек назад",
			"offline": "Сохранено локально · ждёт синхронизации",
			"failed": "Не удалось сохранить"
		},
		"errorTitle": "Не удалось открыть конспект",
		"errorHint": "Возможно, он был удалён или у тебя нет доступа.",
		"backToList": "Вернуться к списку",
		"generatingTitle": "Конспект генерируется",
		"generatingHint": "AI составляет структурированный конспект — это займёт несколько секунд. Страница обновится сама.",
		"regeneratingTitle": "Конспект перегенерируется",
		"regeneratingHint": "AI пересобирает конспект — это займёт пару минут. Новая версия появится здесь автоматически.",
		"regenerateTimeout": "Генерация занимает дольше обычного. Обновите страницу, чтобы увидеть результат.",
		"offlineBanner": "Без сети — изменения сохраняются локально и синхронизируются позже.",
		"image": {
			"loadFailed": "Не удалось загрузить изображение",
			"unsupportedType": "Формат не поддерживается. Загрузите PNG, JPEG, WebP или GIF.",
			"tooLarge": "Файл слишком большой. Максимум — 10 МБ.",
			"uploadFailed": "Не удалось загрузить изображение",
			"zoom": "Открыть изображение на весь экран",
			"close": "Закрыть"
		},
		"mermaid": {
			"label": "Диаграмма",
			"preview": "Превью",
			"code": "Код",
			"sourceLabel": "Источник диаграммы",
			"placeholder": "graph TD; A --> B"
		},
		"citation": {
			"page": "стр. {n}",
			"source": "источник",
			"chunkOrder": "Фрагмент {n}",
			"groupAria": "{count, plural, one {# источник: {name}} few {# источника: {name}} many {# источников: {name}} other {# источника: {name}}}",
			"snippetUnavailable": "Текст фрагмента ещё не загружен."
		},
		"slash": {
			"searchPlaceholder": "Поиск команды…",
			"groups": {
				"ai": "AI",
				"content": "Контент",
				"format": "Формат"
			},
			"items": {
				"ai": "AI-блок",
				"explain": "Объяснить выделение",
				"summary": "Краткое резюме",
				"question": "Задать вопрос",
				"flashcards": "Сгенерировать флэшкарты",
				"quiz": "Сгенерировать тест",
				"cite": "Вставить цитату",
				"glossary": "Добавить в глоссарий",
				"h1": "Заголовок 1",
				"h2": "Заголовок 2",
				"h3": "Заголовок 3",
				"bullet": "Маркированный список",
				"ordered": "Нумерованный список",
				"quote": "Цитата",
				"code": "Блок кода",
				"table": "Таблица 3×3",
				"image": "Изображение",
				"hr": "Разделитель",
				"todo": "Список задач",
				"callout": "Выноска",
				"example": "Привести пример",
				"critique": "Критика",
				"translate": "Перевести",
				"expand": "Развернуть",
				"video": "Видео"
			},
			"prompts": {
				"ai": "Объясни простыми словами",
				"explain": "Объясни выделение для 8-классника",
				"summary": "Краткое резюме",
				"question": "Задать вопрос",
				"demoKrebs": "Объясни цикл Кребса для 8-классника",
				"example": "Приведите конкретный пример этой идеи",
				"critique": "Указать на пробелы и слабые места",
				"translate": "Перевести выделенный текст",
				"expand": "Дополнить деталями"
			},
			"kbd": {
				"navigate": "навигация",
				"select": "выбрать",
				"close": "Закрыть"
			}
		},
		"aiBlock": {
			"ariaLabel": "AI-блок: {type}",
			"regen": "Перегенерировать",
			"delete": "Удалить",
			"pin": "Закрепить как основной",
			"insertAsText": "Вставить как текст",
			"editPrompt": "Редактировать промпт",
			"promptLabel": "Промпт",
			"variant": "Вариант {current} из {total}",
			"stream": "стрим",
			"types": {
				"visualAnalysis": "Разбор изображения",
				"explain": "Объяснение",
				"summary": "Резюме",
				"question": "Вопрос",
				"example": "Пример",
				"critique": "Критика",
				"translate": "Перевод",
				"expand": "Развёрнуто",
				"ai": "AI"
			}
		},
		"toolbar": {
			"bold": "Жирный",
			"italic": "Курсив",
			"underline": "Подчёркнутый",
			"strike": "Зачёркнутый",
			"code": "Код",
			"heading": "Заголовок",
			"paragraph": "Обычный текст",
			"bulletList": "Список",
			"orderedList": "Нумерованный список",
			"quote": "Цитата",
			"highlight": "Подсветка",
			"link": "Ссылка",
			"image": "Изображение",
			"table": "Таблица",
			"slash": "Команды",
			"hl": {
				"yellow": "Жёлтый",
				"green": "Зелёный",
				"pink": "Розовый",
				"blue": "Синий",
				"purple": "Фиолетовый",
				"clear": "Убрать подсветку"
			},
			"linkDialog": {
				"title": "Вставить ссылку",
				"urlLabel": "URL",
				"urlPlaceholder": "https://...",
				"insert": "Вставить",
				"cancel": "Отмена",
				"remove": "Удалить ссылку"
			},
			"taskList": "Список задач",
			"align": "Выравнивание текста",
			"alignLeft": "По левому краю",
			"alignCenter": "По центру",
			"alignRight": "По правому краю",
			"video": "Видео"
		},
		"renameTitleAria": "Переименовать конспект",
		"renameDialog": {
			"title": "Переименовать конспект",
			"placeholder": "Название конспекта",
			"submit": "Сохранить",
			"success": "Конспект переименован",
			"error": "Не удалось переименовать"
		},
		"voice": {
			"input": "Голосовой ввод",
			"recording": "Запись… (нажми, чтобы остановить)",
			"transcribing": "Распознаю…",
			"permissionDenied": "Нет доступа к микрофону",
			"notSupported": "Голосовой ввод не поддерживается в этом браузере",
			"empty": "Запись пустая — попробуйте ещё раз",
			"failed": "Не удалось распознать речь",
			"noSpeech": "Не удалось расслышать речь"
		},
		"table": {
			"grip": {
				"row": "Выделить строку",
				"column": "Выделить столбец",
				"table": "Выделить таблицу"
			},
			"add": {
				"row": "Вставить строку",
				"column": "Вставить столбец"
			},
			"row": {
				"toggleHeader": "Строка-заголовок",
				"insertAbove": "Вставить выше",
				"insertBelow": "Вставить ниже",
				"moveUp": "Переместить вверх",
				"moveDown": "Переместить вниз",
				"delete": "Удалить строку"
			},
			"column": {
				"toggleHeader": "Столбец-заголовок",
				"insertLeft": "Вставить слева",
				"insertRight": "Вставить справа",
				"moveLeft": "Переместить влево",
				"moveRight": "Переместить вправо",
				"delete": "Удалить столбец",
				"sortAsc": "Сортировать по возрастанию",
				"sortDesc": "Сортировать по убыванию",
				"sortDisabledMerged": "Недоступно: в таблице есть объединённые ячейки"
			},
			"align": {
				"label": "Выравнивание",
				"left": "По левому краю",
				"center": "По центру",
				"right": "По правому краю"
			},
			"cells": {
				"merge": "Объединить ячейки",
				"split": "Разъединить ячейку"
			},
			"bg": {
				"label": "Фон",
				"title": "Фон ячеек",
				"none": "Нет",
				"amber": "Янтарный",
				"green": "Зелёный",
				"blue": "Синий",
				"rose": "Розовый",
				"slate": "Серый"
			},
			"table": {
				"distribute": "Выровнять ширины столбцов",
				"toggleHeaderRow": "Строка-заголовок",
				"delete": "Удалить таблицу"
			},
			"menu": {
				"row": "Действия со строкой",
				"column": "Действия со столбцом",
				"table": "Действия с таблицей",
				"cells": "Действия с ячейками"
			},
			"mobile": {
				"title": "Таблица",
				"more": "Ещё",
				"insertRowAbove": "Строка выше",
				"insertRowBelow": "Строка ниже",
				"insertColumnLeft": "Столбец слева",
				"insertColumnRight": "Столбец справа"
			}
		},
		"editMode": "Редактировать",
		"readMode": "Готово",
		"bubble": {
			"ariaLabel": "Форматирование текста",
			"clear": "Очистить форматирование",
			"ai": "Запросить AI по выделенному тексту"
		},
		"dragHandle": {
			"ariaLabel": "Перетащить блок"
		},
		"toc": {
			"title": "Структура",
			"ariaLabel": "Оглавление",
			"open": "Открыть структуру"
		},
		"composer": {
			"title": "ИИ: {type}",
			"editTitle": "Редактировать запрос",
			"promptLabel": "Промпт",
			"contextLabel": "Контекст",
			"noContext": "Текст не выбран — модель ответит на запрос в свободной форме.",
			"languageLabel": "Целевой язык",
			"cancel": "Отмена",
			"create": "Создать",
			"save": "Сохранить"
		},
		"video": {
			"dialogTitle": "Вставить видео",
			"tabLink": "Ссылка",
			"tabFile": "Файл",
			"urlLabel": "URL видео",
			"urlPlaceholder": "Ссылка на YouTube или Vimeo",
			"insert": "Вставить",
			"cancel": "Отмена",
			"invalidUrl": "Этот хостинг не поддерживается. Используйте YouTube или Vimeo.",
			"unsupportedType": "Неподдерживаемый формат. Загрузите MP4, WebM или MOV.",
			"tooLarge": "Файл слишком большой. Максимальный размер — 50 МБ.",
			"loadFailed": "Не удалось загрузить видео",
			"fileHint": "Короткий видеоролик в заметке, до 50 МБ (MP4, WebM, MOV).",
			"chooseFile": "Выберите файл",
			"uploadFailed": "Не удалось загрузить видео"
		}
	},
	"versions": {
		"title": "История версий",
		"subtitle": "{title}",
		"empty": "Это единственная версия",
		"emptyHint": "Регенерация или ручное сохранение создаст snapshot.",
		"selected": "выбрано",
		"current": "Текущая",
		"restore": "Восстановить эту версию",
		"reasons": {
			"manual_save": "Автосохранение",
			"ai_regenerate": "Регенерация",
			"restore": "Восстановление",
			"current": "Текущая версия"
		},
		"restored": "Версия восстановлена",
		"restoreFailed": "Не удалось восстановить версию",
		"previewEmpty": "В этой версии нет содержимого",
		"authorAi": "AI",
		"authorYou": "Вы",
		"diff": {
			"changes": "Изменения",
			"preview": "Превью",
			"toggle": "Вид версии",
			"identical": "Эта версия совпадает с текущей",
			"collapsed": "··· {count, plural, one {# строка без изменений} few {# строки без изменений} many {# строк без изменений} other {# строк без изменений}} ···"
		}
	},
	"glossaryTooltip": {
		"viewDefinition": "Открыть определение",
		"tapHint": "Нажмите на термин, чтобы увидеть определение"
	},
	"glossaryAdd": {
		"title": "Добавить в глоссарий",
		"description": "Термин и определение появятся в словаре материала и будут подсвечиваться в конспекте.",
		"termLabel": "Термин",
		"termPlaceholder": "Например: Цикл Кребса",
		"definitionLabel": "Определение",
		"definitionPlaceholder": "Краткое объяснение термина",
		"submit": "Добавить",
		"added": "Термин добавлен в глоссарий",
		"failed": "Не удалось добавить термин"
	},
	"actions": {
		"regenerate": "Перегенерировать",
		"duplicate": "Дублировать",
		"export": "Экспорт",
		"exportPdf": "Экспорт в PDF",
		"exportMarkdown": "Экспорт в Markdown",
		"delete": "Удалить",
		"openMaterial": "Открыть материал",
		"rename": "Переименовать"
	},
	"wordCount": "{count, plural, one {# слово} few {# слова} many {# слов} other {# слова}}",
	"workspace": {
		"backToMaterial": "Назад к материалу",
		"notesTab": "Конспекты",
		"notesTitle": "Конспекты материала",
		"generateTitle": "Сгенерировать AI-конспект",
		"empty": "По этому материалу ещё нет конспектов. Сгенерируй или создай вручную.",
		"open": "Открыть",
		"genFailed": "Не удалось запустить генерацию",
		"generatingHint": "Конспект генерируется — это займёт до минуты. Откроется автоматически."
	},
	"savedAnswer": {
		"badge": "Сохранённый ответ",
		"untitled": "Сохранённый ответ",
		"back": "Назад",
		"viewOnly": "Сохранённые ответы доступны только для чтения — текст остаётся в исходном виде.",
		"convertToSource": "Преобразовать в источник",
		"convertUnavailable": "Этот ответ не привязан к курсу, поэтому его некуда добавить.",
		"convertSuccess": "Добавлено в источники курса",
		"convertNotAttached": "Материал создан, но не добавлен в курс",
		"convertNotAttachedHint": "Найдите его в своей библиотеке и добавьте в курс вручную.",
		"convertFailed": "Не удалось создать материал",
		"materialCreated": "Открыть материал",
		"openConversation": "Открыть диалог",
		"convertDone": "Добавлено в источники курса"
	},
	"intro": {
		"title": "Конспект — не копия материала",
		"body": "Сжатый пересказ вашего источника: ИИ собирает, вы правите как обычный документ. Ссылки на исходные фрагменты остаются на месте.",
		"bullets": [
			"Три уровня подробности — от выжимки до разбора",
			"Каждый тезис ведёт к фрагменту, откуда взят",
			"История версий: любую правку можно откатить"
		]
	}
}
